import { render, staticRenderFns } from "./VideoMail.vue?vue&type=template&id=05cb230e&scoped=true&"
import script from "./VideoMail.vue?vue&type=script&lang=js&"
export * from "./VideoMail.vue?vue&type=script&lang=js&"
import style0 from "./VideoMail.vue?vue&type=style&index=0&id=05cb230e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cb230e",
  null
  
)

export default component.exports